import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  header: {
    background: 'linear-gradient(120deg, #0d3b8c, #1b57c1)',
    color: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '62px',
    borderRadius: '12px',
    boxShadow: '0 14px 30px rgba(13, 59, 140, 0.35)',
    textTransform: 'uppercase',
    letterSpacing: '0.08rem',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontWeight: 600,
    fontSize: '1.2rem',
  },
  brandLogo: {
    height: '38px',
    width: 'auto',
    maxWidth: '130px',
    objectFit: 'contain',
    display: 'block',
  },
  clockIcon: {
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    background: '#ffffff',
    border: '2px solid #0d3b8c',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 10px rgba(13, 59, 140, 0.2)',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '2px',
      height: '8px',
      background: '#0d3b8c',
      borderRadius: '2px',
      transform: 'translateY(-2px)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '6px',
      height: '2px',
      background: '#0d3b8c',
      borderRadius: '2px',
      transformOrigin: 'left center',
      transform: 'translateX(2px) rotate(35deg)',
    },
  },
}));

const Header = ({ title }) => {
  const classes = useStyles();
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className={classes.header}>
      <div className={classes.brand}>
        {!logoFailed ? (
          <img
            className={classes.brandLogo}
            src={`${process.env.PUBLIC_URL || ''}/brand-logo.png`}
            alt="24H Jobs Posted Today"
            onError={() => setLogoFailed(true)}
          />
        ) : (
          <div className={classes.clockIcon} />
        )}
        <span>{title}</span>
      </div>
    </div>
  );
};

export default Header;
